import React from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';

/**
 * 상단 로고/메뉴 영역 제어 컴포넌트
 * 원본: header-bottom-control.html
 */
const HeaderBottomControl = () => {
  const themeContext = useTheme();
  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  return (
    <div id="header-bottom-control-section" style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
        <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>🌈 메뉴 영역 스타일:</label>
        <button
          type="button"
          className="theme-help-btn"
          data-target="header-bottom-control-section"
          title="이 항목으로 이동"
          style={{
            background: 'transparent',
            border: '1px solid #ddd',
            color: '#666',
            fontSize: '11px',
            width: '20px',
            height: '20px',
            padding: 0,
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = 'var(--theme-color-primary)';
            e.target.style.color = 'var(--theme-color-primary)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = '#ddd';
            e.target.style.color = '#666';
          }}
        >
          ?
        </button>
      </div>
      <div style={{ fontSize: '11px', color: '#999', marginBottom: '12px', lineHeight: 1.4 }}>
        메뉴 영역(.header-bottom)과 사이드 내비게이션(.nav-layout)의 배경색과 기본 글자색을 설정합니다. 입력값은 HEX 형식(#RRGGBB)이어야 합니다.
      </div>
      <div style={{ marginBottom: '12px' }}>
        <label style={{ fontSize: '12px', fontWeight: 500, color: '#666', marginBottom: '6px', display: 'block' }}>
          배경색
        </label>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="color"
            value={themeConfig.headerBottomBackgroundColor}
            onChange={(e) => set('headerBottomBackgroundColor', e.target.value)}
            style={{ width: '50px', height: '35px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <input
            type="text"
            value={themeConfig.headerBottomBackgroundColor}
            onChange={(e) => set('headerBottomBackgroundColor', e.target.value)}
            style={{ flex: 1, padding: '6px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '12px' }}
          />
        </div>
      </div>
      <div style={{ marginBottom: '12px' }}>
        <label style={{ fontSize: '12px', fontWeight: 500, color: '#666', marginBottom: '6px', display: 'block' }}>
          글자색
        </label>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="color"
            value={themeConfig.headerBottomTextColor}
            onChange={(e) => set('headerBottomTextColor', e.target.value)}
            style={{ width: '50px', height: '35px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <input
            type="text"
            value={themeConfig.headerBottomTextColor}
            onChange={(e) => set('headerBottomTextColor', e.target.value)}
            style={{ flex: 1, padding: '6px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '12px' }}
          />
        </div>
      </div>
      {/* 높이 제어 */}
      <div style={{ marginBottom: '18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
          <label htmlFor="header-bottom-height-input" style={{ fontSize: '12px', color: '#666', fontWeight: 500, cursor: 'pointer' }}>
            높이 (상하 패딩):
          </label>
          <button
            type="button"
            id="reset-header-bottom-height-btn"
            onClick={() => {
              set('headerBottomHeight', 15);
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = themeConfig.themeColor || '#e97730';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#ddd';
            }}
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '10px',
              padding: '2px 8px',
              borderRadius: '3px',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
          >
            리셋
          </button>
        </div>
        <div style={{ position: 'relative' }}>
          <input
            type="number"
            id="header-bottom-height-input"
            step="1"
            min="0"
            max="100"
            value={themeConfig.headerBottomHeight || 15}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              if (!isNaN(value) && value >= 0 && value <= 100) {
                set('headerBottomHeight', value);
              }
            }}
            onBlur={(e) => {
              const value = parseInt(e.target.value, 10);
              if (isNaN(value) || value < 0 || value > 100) {
                const currentValue = themeConfig.headerBottomHeight || 15;
                e.target.value = currentValue;
                set('headerBottomHeight', currentValue);
              }
            }}
            placeholder="15"
            style={{
              width: '100%',
              padding: '6px 10px',
              paddingRight: '35px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px',
              fontFamily: 'monospace',
              textAlign: 'center'
            }}
          />
          <div style={{
            position: 'absolute',
            right: '8px',
            bottom: '6px',
            fontSize: '11px',
            color: '#999',
            pointerEvents: 'none'
          }}>
            px
          </div>
        </div>
        <div style={{ fontSize: '10px', color: '#999', marginTop: '4px', lineHeight: '1.4' }}>
          상단과 하단에 동일한 패딩이 적용됩니다.
        </div>
      </div>
    </div>
  );
};

export default HeaderBottomControl;

